import { useState } from 'react';
import Label from '../Label/Label';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import styles from './MultiSelect.module.scss';
import { default as ReactSelect } from 'react-select';
import useTranslation from '../../../Hooks/useTranslation';

interface IMultiSelect {
	onChange?: any;
	onChangeExtra?: any;
	onFocus?: any;
	placeholder?: string;
	required?: boolean;
	value?: any;
	label?: string;
	firstUpper?: boolean;
	className?: string;
	options: any;
	isSearchable?: boolean;
	closeMenuOnSelect?: boolean;
	noOptionsMessage?: string;
}

export default function MultiSelect(props: IMultiSelect) {
	const {
		label,
		onChange,
		noOptionsMessage,
		onChangeExtra,
		closeMenuOnSelect = false,
		onFocus,
		placeholder = 'base.shared.pick',
		required = false,
		value,
		firstUpper = false,
		className,
		options,
		isSearchable = false,
	} = props;

	const { t } = useTranslation();

	const handleOnChange = e => {
		onChange?.(e);
		onChangeExtra?.(e);
	};

	const customStyles = {};

	return (
		<div className={styles.wrapper}>
			{label && <Label tx={label} firstUpper={firstUpper} />}
			<ReactSelect
				noOptionsMessage={() => noOptionsMessage ?? t('base.noOptions')}
				options={options}
				classNamePrefix={'reactSelect'}
				styles={customStyles}
				placeholder={t(placeholder)}
				onEmptied={handleOnChange}
				onChange={handleOnChange}
				isMulti={true}
				isSearchable={isSearchable}
				defaultValue={value}
				closeMenuOnSelect={closeMenuOnSelect}
				menuPosition='fixed'
			/>
		</div>
	);
}
